import About from "components/homepage/About";
import Contact from "components/homepage/Contact";
import Header from "components/homepage/Header";
import Landing from "components/homepage/Landing";
import Media from "components/homepage/Media";
import Platform from "components/homepage/Platform";
import Team from "components/homepage/Team";
import { useEffect, useState } from "react";

/**
 * * Root page for website
 * @returns {React.ReactElement} HomePage
 */
export default function HomePage() {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const onScroll = (e) => {
      setScrollTop(e.target.documentElement.scrollTop);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div id="home-page" data-testid="home-page">
      <Header scrollTop={scrollTop} />
      <Landing />
      <About />
      <Platform />
      <Team />
      <Media />
      <Contact />
    </div>
  );
}
